import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import LocalDataService from '../api/LocalDataService';

export function isAuthenticated() {
  const user = LocalDataService.load_user_data();
  return Boolean(user && user.token);
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (isAuthenticated()) return <Component {...props} />;

      const requestedPath = `${props.location.pathname}${props.location.search}`;
      return <Redirect to={`/login?redirect=${encodeURIComponent(requestedPath)}`} />;
    }}
  />
);

export default PrivateRoute;
